import giftCard from "./fr-gift-card.json";
import accountDetails from "./fr-account-details.json";
import checkoutForm from "./fr-checkout-form.json";
import footer from "./fr-footer.json";
import auth from "./fr-auth.json";
import hamburgerMenu from "./fr-hamburger-menu.json";
import teamGlobal from "./fr-team-global.json";

export const fr = {
  giftCard,
  accountDetails,
  checkoutForm,
  footer,
  auth,
  hamburgerMenu,
  teamGlobal,
};
